import React from 'react';
import Header from '../Header/Header';
import './Dashboard.css'

const Dashboard = () => {
    return (
        <div id='dashboard'>
            <Header></Header>
            <div className="container">
                <h1>Hello from dashboard</h1>
            </div>
        </div>
    );
};

export default Dashboard;